(function () {
  'use strict';

  function initContactForm() {
    var root = document.querySelector('[data-bb-contact]');
    if (!root) return;

    var form = root.querySelector('[data-bb-contact-form]');
    var statusEl = root.querySelector('[data-bb-contact-status]');
    var submitBtn = root.querySelector('[data-bb-contact-submit]');
    if (!form || !submitBtn) return;

    var endpoint =
      (window.BB_CONTACT && window.BB_CONTACT.endpoint) ||
      'https://checkout.lifesofbooks.com/api/contact';

    function setStatus(message, state) {
      if (!statusEl) return;
      if (!message) {
        statusEl.hidden = true;
        statusEl.textContent = '';
        statusEl.removeAttribute('data-state');
        return;
      }
      statusEl.hidden = false;
      statusEl.textContent = message;
      statusEl.setAttribute('data-state', state || '');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setStatus('');

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var data = new FormData(form);
      if (data.get('website')) {
        setStatus('Thanks! Your message has been sent.', 'success');
        form.reset();
        return;
      }

      var payload = {
        name: String(data.get('name') || '').trim(),
        email: String(data.get('email') || '').trim(),
        phone: String(data.get('phone') || '').trim(),
        comment: String(data.get('comment') || '').trim(),
      };

      submitBtn.disabled = true;
      var originalLabel = submitBtn.textContent;
      submitBtn.textContent = 'Sending…';

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res.json().catch(function () {
            return {};
          }).then(function (body) {
            if (!res.ok) {
              throw new Error(body.error || 'Something went wrong. Please try again.');
            }
            return body;
          });
        })
        .then(function () {
          setStatus('Thanks! Your message has been sent. We\'ll reply within 48 hours.', 'success');
          form.reset();
        })
        .catch(function (err) {
          setStatus(err.message || 'Unable to send your message. Please email support@lifesofbooks.com.', 'error');
        })
        .finally(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactForm);
  } else {
    initContactForm();
  }
})();
